









































































































































import { getCompanyMeasure } from "@/services/api";
import { isEnableAttributionWindow, isEnableAttributionWindow20260609, isEnableAttributionWindow20260611, isEnableAuth } from "@/utils/experiment";
import { normalizeAbtestMeasures } from "@/utils/abtestMeasure";
import { shouldUseAbtestAttributionMetrics } from "@/utils/abtestMetricDisplay";
import { getCompanyInfo } from "@/utils/getCompanyInfo";
import { Component, Vue, Prop ,Watch } from "vue-property-decorator";
import { inAuthority } from "@/utils/authority";


@Component({})
export default class ABTestDisplayTable extends Vue {
  @Prop()
  tableDetail?:any;

  @Prop()
  chooseState?: boolean;

  tableData:any[] = [];
  chooseResult = '';

  @Watch('chooseResult')
  updateChoose() {
    this.$emit('updateChooseResult', this.chooseResult);
  }

  get enableAuth() {
    return isEnableAuth();
  }

  get enableAttributionWindow() {
    return isEnableAttributionWindow();
  }

  get showAttributionMetrics() {
    return shouldUseAbtestAttributionMetrics(this.tableDetail?.metricDisplayMode, this.enableAttributionWindow);
  }

  public inAuthorityFun(menu:any,key:any){
    return inAuthority(menu,key)
  }

  get columnsMap() {
    return {
      'viewCnt': this.$tx('brand.monitor.views', '曝光用户数'),
      'signupCnt': this.$tx('brand.monitor.submits', '提交用户数'),
      'signupRate': this.$tx('form.submitRate', '提交转化率'),
      ...(this.showAttributionMetrics ? {
        'orderGmv': this.$tx('form.list.col.sales', '销售额'),
        'orderCntNew': this.$tx('form.list.col.orders', '订单数'),
        'orderAtv': this.$tx('form.list.col.aov', '客单价')
      } : {}),
      'orderRate': this.enableAttributionWindow ? this.$tx('form.ab.orderRateIp', '下单转化率（IP）') : this.$tx('form.ab.orderRate', '下单转化率'),

      'phoneCnt': this.$tx('form.list.col.phone', '收集手机号总量'),
      'viewRate': this.$tx('form.ab.impressionRate', '曝光率'),
      'orderCnt': this.enableAttributionWindow ? this.$tx('form.ab.orderCntIp', '下单数（IP）') : this.$tx('form.ordersPlaced', '下单数'),

      ...(this.enableAuth ? {
        'loginEmailCnt': this.$tx('form.list.col.loginEmail', '第三方登录收集邮箱总量'),
        'loginSignUpCnt': this.$tx('form.list.col.loginSignup', '第三方登录提交用户数')
      } : {}),
    }
  }

  attributionStartTime = isEnableAttributionWindow20260609()
    ? '2026-06-09'
    : isEnableAttributionWindow20260611()
      ? '2026-06-11'
      : '2026-06-16'

  get metricTooltipMap() {
    return {
    orderCnt: this.$tx('form.ab.tooltip.orderCntIp', '该活动弹窗引导产生的下单数(按访客IP级统计)。订阅工具列表中的下单数按归因口径(用户弹窗提交信息匹配)统计,请注意两侧口径差异。'),
    orderRate: this.$tx('form.ab.tooltip.orderRateIp', '该活动弹窗引导产生的下单转化率(按访客IP统计)。订阅工具列表中的订单数据基于用户弹窗提交信息匹配统计,请注意两侧口径差异。'),
    orderGmv: this.$tx('form.list.tooltip.orderGmv', '该弹窗引导产生的订单销售额汇总（基于用户弹窗提交的邮箱/手机号匹配归因）；未触发归因起点的弹窗显示为 0；指标自 {{date}} 起生效。', { date: this.attributionStartTime }),
    orderCntNew: this.$tx('form.list.tooltip.orderCnt', '该弹窗引导产生的订单数（基于用户弹窗提交的邮箱/手机号匹配归因）；未触发归因起点的弹窗（如无提交步骤 / 未到达成功页）显示为 0；指标自 {{date}} 起生效。', { date: this.attributionStartTime }),
    orderAtv: this.$tx('form.list.tooltip.orderAtv', '该弹窗引导下订单的平均金额，计算方式为 归因销售额 ÷ 归因订单数；订单数为 0 时显示为 0；指标自 {{date}} 起生效。', { date: this.attributionStartTime })
    }
  }

  tableColumnsList = this.enableAuth
    ? [
      'viewCnt', 'loginEmailCnt', 'signupCnt', 'loginSignUpCnt', 'signupRate',
      ...(this.showAttributionMetrics
        ? ['orderGmv', 'orderCntNew', 'orderAtv'] as any
        : []
      ),
      ...(this.showAttributionMetrics ? [] : ['orderRate'])
    ]
    : [
      'viewCnt', 'signupCnt', 'signupRate',
      ...(this.showAttributionMetrics
        ? ['orderGmv', 'orderCntNew', 'orderAtv'] as any
        : []
      ),
      ...(this.showAttributionMetrics ? [] : ['orderRate'])
    ];

  @Watch('tableDetail')
  getAbtestData() {
    this.tableData = this.tableDetail?.abFormList || [];
    let hasClose = false;
    for (let i = 0; i < this.tableData.length; i++) {
      const item:any = this.tableData[i];
      if (item.type === null) {
        hasClose = true;
        break;
      }
    }
    // 计算各种率
    for (let i = 0; i < this.tableData.length; i++) {
      const item:any = this.tableData[i];
      const userCnt:number = item.participationCnt;
      const userViewCnt:number = item.viewCnt;
      if (userViewCnt > 0) {
        item.signupRate = item.signupCnt > 0 ? `${((item.signupCnt / userViewCnt) * 100).toFixed(2)}%` : '0';
      } else {
        item.signupRate = '-';
      }
      if (hasClose) {
      if (userCnt > 0) {
        item.orderRate = item.orderCnt > 0 ? `${((item.orderCnt / userCnt) * 100).toFixed(2)}%` : '0';
        item.viewRate = item.viewCnt > 0 ? `${((item.viewCnt / userCnt) * 100).toFixed(2)}%` : '0';
      } else {
        item.orderRate = '-';
        item.viewRate = '-';
      }
      } else {
      if (userViewCnt > 0) {
        item.orderRate = item.orderCnt > 0 ? `${((item.orderCnt / userViewCnt) * 100).toFixed(2)}%` : '0';
      } else {
        item.orderRate = '-';
      }
      if (userCnt > 0) {
        item.viewRate = item.viewCnt > 0 ? `${((item.viewCnt / userCnt) * 100).toFixed(2)}%` : '0';
      } else {
        item.viewRate = '-';
      }
      }
    }
    getCompanyMeasure({
      measureCategory: "FORMABTEST"
    }, true).then((res) => {
      const measures = normalizeAbtestMeasures(
        res.data.data.measures || [],
        this.tableDetail?.metricDisplayMode,
        this.showAttributionMetrics
      );
      if(measures?.length){
        this.tableColumnsList = measures
      }
    })
  }
  mounted() {
    // this.tableData = JSON.parse(JSON.stringify(this.tableDetail?.items || []));
    // this.tableData = this.tableDetail?.abFormList || [];
    getCompanyMeasure({
      measureCategory: "FORMABTEST"
    }, true).then((res) => {
      const measures = normalizeAbtestMeasures(
        res.data.data.measures || [],
        this.tableDetail?.metricDisplayMode,
        this.showAttributionMetrics
      );
      if(measures?.length){
        this.tableColumnsList = measures
      }
    })
  }

  displayItem(scope:any) {
    if (scope.row.type == 1) {
      window.open(`/wheel_of_fortune/setting/${scope.row.formId}?abtest=true&abtestid=${this.tableDetail.id}`)
    }else if(scope.row.type == 2){
      window.open(`/wheel_of_fortune/pop/${scope.row.formId}?abtest=true&abtestid=${this.tableDetail.id}`)
    }
  }

}
